import React, { useState, useEffect, useRef } from 'react';
import {
  TextField,
  Button,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableFooter,
  TablePagination,
  Menu,
  MenuItem,
  InputAdornment,
  Checkbox,
} from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import { AddCircle, RemoveCircle, DragIndicator, MoreHoriz } from '@material-ui/icons';
import CreateIcon from '@material-ui/icons/Create';
import TablePaginationActions from '../../../../../shared/table-pagination/TablePaginationActions';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import DeletePopupModel from '../../../../../shared/delete-popup/Delete-Popup';
import {
  ROOM_TYPE_CREATE,
  ROOM_TYPE_EDIT,
  ROOM_TYPE_VIEW,
} from '../../../../../constants/AccomodationConst';
import {
  RBAC_PERMISSION_LEVEL_FULL_ACCESS,
  RBAC_TYPE_HOTEL_ACCOMMODATIONS,
} from '../../../../../constants/RoleConsts';
import LinearProgressBar from '../../../../../shared/progress-bar/Progress';
import { useSelector, useDispatch } from 'react-redux';
import {
  allCategoriesSelector,
  allRoomsSelector,
  allRoomTypesSelector,
  fetchAllAccommodations,
  setAllRoomTypes,
} from '../../../../property/propertySlice';
import { campainNotificatons, emailServicesSelector } from '../../../../services/servicesSlice';
import './RoomType-List.scss';
import ListFilterMenu from '../../../../../shared/list-filter-menu/List-Filter-Menu';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import {
  deleteAccommodationRoomTypeAPI,
  deleteSelectedItems,
  updateSelectedItemsStatus,
  getWelcomeMessages,
} from '../../../../../utils/ServicesAPIUtils';
import { notificationManager } from '../../../../../utils/NotificationUtils';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import useOutsideAlerter from '../../../../../custom-hooks/useOutsideAlerter';
import { handleOnDragEnd } from '../../../../../shared/custom-dragdrop/dragDrop';
import WarningPopup from '../../../../../shared/warning-popup/Warning-Popup';
import { SaveButton } from '../../../../../shared/custom-dragdrop/Save-Button';
import { createDataSortMapping } from '../../../../../utils/PropertyAPIUtils';
import CustomChip from '../../../../../shared/form-controls/custom-chip/Custom-Chip';
import {
  accommodationRoomTypeActivate,
  accommodationRoomTypeDeactivate,
} from '../../../../../utils/ServicesAPIUtils';
import ActionMenuList from '../../../../../shared/ActionMenuList/ActionMenuList';
import MultipleDeleteConfirmationPopup from '../../../../../shared/MultiActionPopUp/MultiDeleteConfirmationPopup';
import {
  PARTIAL_CHECKBOX_GREEN,
  ResetFilterList,
  getCheckedIds,
  isDragDisabled,
  selectedCheckList,
  updateCheckedStatus,
  updateSelectedModule,
} from '../../../../../utils/formUtils';
import { generateConfirmationMessage } from '../../../../../utils/formUtils';
import MultipleSelectionAlert from '../../../../../shared/MultiActionPopUp/MultipleSelectionAlert';
import BulkActionCheckBox from '../../../../../shared/MultiActionPopUp/BulkActionCheckBox';
import { decryptLocalStorage } from '../../../../../utils/authUtils';
import { stepDownLoaderCount, stepUpLoaderCount } from '../../../../../utils/loaderSlice';

const RoomTypeList = (props) => {
  const {
    onDrawerToggle,
    onViewToggle,
    selectedHotel,
    permissions,
    page,
    rowsPerPage,
    onsetRowsPerPage,
    onsetPage,
  } = props;
  const [selectedValue, setSelectedValue] = useState({
    id: '',
    name: '',
    title: '',
    description: '',
    status: false,
    anchorEl: null,
  });
  const originalRoomTypes = useSelector(allRoomTypesSelector);
  const allNotificationsOriginal = useSelector(campainNotificatons);
  const emailServicesList = useSelector(emailServicesSelector);
  const originalCategories = useSelector(allCategoriesSelector);
  const [roomTypes, setRoomTypes] = useState([]);
  const [filteredBaseList, setFilteredBaseList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [filterTargetButton, setFilterTargetButton] = useState(null);
  const [filterMenu, setFilterMenu] = useState([]);
  const originalRooms = useSelector(allRoomsSelector);
  const dispatch = useDispatch();
  const [popUp, setPopUp] = useState(false);
  const [visible, setVisible] = useState(false);
  const wrapperRef = useRef(null);
  const searchRef = useRef(null);
  const filterRef = useRef(null);
  const [searchText, setSearchText] = useState('');
  const [searchButton, setSearchButton] = useState(true);
  const [actionMenuAnchorEl, setActionMenuAnchorEl] = useState(null);
  const [isAllSelected, setIsAllSelected] = useState(false);
  const [actionMenuList, setActionMenuList] = useState([]);
  const [actionName, setActionName] = useState(false);
  const [isActive, setIsActive] = useState(false);
  const [showMultipleDeleteConfirmation, setShowMultipleDeleteConfirmation] = useState(false);
  const [showBulkActiveDeactiveConfirmation, setShowBulkActiveDeactiveConfirmation] =
    useState(false);
  const [showBulkKebabSelectionAlert, setShowBulkKebabSelectionAlert] = useState(false);
  const [showBulkSearchAlert, setShowBulkSearchAlert] = useState(false);
  const [showBulkFilterAlert, setShowBulkFilterAlert] = useState(false);
  const isFilterApplied = useRef(false);
  const prevHotelIdRef = useRef(selectedHotel);

  useEffect(() => {
    // assigning data set to local list while keeping an orginal data set for filtering
    const roomTypeList = originalRoomTypes.map((obj) => {
      const catObj = originalCategories.find((c) => c.id === obj.categoryId);
      const returnObj = {
        ...obj,
        category: catObj ? catObj.name : '',
        status: obj?.isActive ? 'active' : 'inactive',
        isChecked: false,
      };
      return returnObj;
    });
    setRoomTypes(roomTypeList);
  }, [originalRoomTypes, originalCategories]);

  const getCheckedRoomTypeList = roomTypes?.filter((roomType) => roomType?.isChecked);

  const listOfRoomTypeIds = getCheckedRoomTypeList?.map((roomType) => roomType?.id);

  const selectedInitialRoomTypeLength = getCheckedRoomTypeList?.length;
  const selectedRoomTypeLength = roomTypes?.filter((room) => room?.isChecked)?.length;

  useEffect(() => {
    updateSelectedModule(roomTypes, setActionMenuList, setIsAllSelected);
  }, [roomTypes]);

  const resetFilterDataList = () => {
    const baseMenu = [
      { title: 'All', field: 'all', subMenu: [] },
      {
        title: 'Status',
        field: 'status',
        subMenu: [
          { id: 'active', name: 'Active', selected: false },
          { id: 'inactive', name: 'Inactive', selected: false },
        ],
      },
    ];

    const fullMenu = [...baseMenu];
    if (originalCategories?.length) {
      const filterMenuCats = originalCategories?.map((obj) => ({
        id: obj?.id,
        name: obj?.name,
        selected: false,
      }));
      fullMenu?.push({
        title: 'Categories',
        field: 'categoryId',
        subMenu: filterMenuCats,
      });
    }

    setFilterMenu(fullMenu);
  };

  useEffect(() => {
    setSearchText('');
    setFilteredBaseList(originalRoomTypes);
    setRoomTypes((prevList) => {
      return originalRoomTypes?.map((roomType) => {
        const isChecked = selectedCheckList(prevList, roomType.id);
        return {
          ...roomType,
          isChecked,
        };
      });
    });
  }, [originalRoomTypes]);

  useEffect(() => {
    resetFilterDataList();
  }, [originalCategories]);

  useEffect(() => {
    if (loading || roomTypes?.length === 0) return;
    const totalItems = roomTypes?.length;
    const maxPageIndex = Math.max(Math.ceil(totalItems / rowsPerPage) - 1, 0);
    if (page > maxPageIndex) {
      onsetPage(maxPageIndex);
    }
  }, [roomTypes?.length, rowsPerPage, page, onsetPage]);

  useEffect(() => {
    if (prevHotelIdRef?.current !== selectedHotel) {
      onsetPage(0);
    }
    prevHotelIdRef.current = selectedHotel;
  }, [selectedHotel]);

  const handleSearchText = (searchText) => {
    setSearchText(searchText);
    const checkedIdList = getCheckedIds(roomTypes, 'isChecked');
    const filteredRows = filteredBaseList.filter((item) =>
      item.name?.toLowerCase().includes(searchText.toLowerCase()),
    );
    const updatedCheckedList = updateCheckedStatus(filteredRows, checkedIdList);
    onsetPage(0);
    setRoomTypes(updatedCheckedList);
  };

  const handleChangePage = (event, newPage) => {
    onsetPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    onsetRowsPerPage(parseInt(event.target.value, 10));
    onsetPage(0);
  };

  const onOpenDrawer = (event, type) => {
    if (selectedInitialRoomTypeLength) {
      setRoomTypes(ResetFilterList);
    }
    event.stopPropagation();
    onDrawerToggle(type, true, selectedValue.roomType);
    handleClose();
  };

  const handleClose = () => {
    setSelectedValue({
      id: '',
      name: '',
      title: '',
      description: '',
      status: false,
      anchorEl: null,
      roomType: null,
    });
  };

  const handleCellMenuClick = (event, roomType) => {
    event.stopPropagation();
    if (selectedInitialRoomTypeLength > 1) {
      setShowBulkKebabSelectionAlert(true);
    } else {
      setSelectedValue({
        id: roomType.id,
        name: roomType.name,
        title: '',
        description: '',
        status: false,
        anchorEl: event.currentTarget,
        roomType: roomType,
        isActive: roomType.isActive,
      });
    }
  };

  const deleteAccommodationRoomType = async (e, type) => {
    e.preventDefault();

    const selectedRoomType = allNotificationsOriginal?.map((item) => item.residentRoomType);
    const uniqueRoomType = [...new Set(selectedRoomType)];
    const notificationMapped = uniqueRoomType.toString().includes(type);

    const emailMapped = (emailServicesList || [])?.some((s) =>
      s?.audience?.guests?.roomTypes?.values?.includes(type),
    );

    let welcomeMapped = false;
    try {
      if (selectedHotel) {
        const lang = decryptLocalStorage('lang');
        const getByLang = lang !== 'en' ? lang : '';
        const res = await getWelcomeMessages(selectedHotel, getByLang);
        const messages = res?.data?.listWelcomeMessage || [];
        welcomeMapped = messages?.some((m) =>
          m?.audienceCriteria?.roomTypes?.values?.includes(type),
        );
      }
    } catch (err) {
      // ignore fetch errors and treat as not mapped
    }

    const modules = [];
    if (emailMapped) modules.push('Email Templates');
    if (notificationMapped) modules.push('Notifications');
    if (welcomeMapped) modules.push('Welcome Messages');

    if (modules.length > 0) {
      const description =
        modules.length === 1
          ? `The selected room type cannot be deleted as it has been configured under one or more ${modules[0]}.`
          : `The selected room type cannot be deleted as it has been configured under one or more ${modules.join(
              ' and ',
            )}.`;

      setSelectedValue((prev) => ({
        ...prev,
        title: 'Unable to delete',
        description,
        status: true,
        anchorEl: null,
        warn: true,
        buttonName: 'Back',
      }));
    } else {
      setSelectedValue((prev) => ({
        ...prev,
        title: 'Are you sure you want to delete',
        description:
          'This action cannot be reversed. Information associated with this room type will also be lost.',
        status: true,
        anchorEl: null,
      }));
    }
  };

  const deleteRoomType = async () => {
    try {
      if (selectedHotel && selectedValue && selectedValue.id) {
        const lang = decryptLocalStorage('lang');
        const delByLang = lang !== 'en' ? lang : '';
        const res = await deleteAccommodationRoomTypeAPI(
          selectedHotel,
          selectedValue.id,
          delByLang,
        );
        if (res.data.deleteRoomType.status === 'Success') {
          dispatch(fetchAllAccommodations(selectedHotel));
          notificationManager('success', 'Room Type deleted successfully');
        } else {
          notificationManager('danger', 'Failed to delete Room Type');
        }
      }
      handleClose();
    } catch (e) {
      if (e.graphQLErrors) {
        notificationManager('danger', e.graphQLErrors[0].message);
      } else {
        notificationManager('danger', 'Failed to delete Room Type');
      }
      handleClose();
    }
    setIsAllSelected(false);
    setActionMenuList([]);
  };

  const onDeleteCancel = () => {
    setSelectedValue({
      id: '',
      name: '',
      title: '',
      description: '',
      status: false,
      anchorEl: null,
    });
  };

  const onViewDetails = (roomType, e) => {
    if (e?.target?.tagName === 'TD') {
      onViewToggle(ROOM_TYPE_VIEW, true, roomType);
    }
  };

  const onClickView = (e) => {
    if (selectedValue && selectedValue.roomType) {
      onViewToggle(ROOM_TYPE_VIEW, true, selectedValue.roomType);
    }
  };

  const handleFilterMenu = (event) => {
    if (selectedInitialRoomTypeLength > 0) {
      setShowBulkFilterAlert(true);
      return;
    } else {
      setFilterTargetButton(event.currentTarget);
      // setAnchorEl(event.currentTarget);
    }
  };

  const handleContinue = (isFromFilterContinue = false) => {
    setShowBulkSearchAlert(false);
    setRoomTypes((prev) =>
      prev.map((room) => ({
        ...room,
        isChecked: false,
      })),
    );

    setTimeout(() => {
      if (isFromFilterContinue) {
        filterRef?.current?.click();
      } else {
        searchRef?.current?.focus();
      }
    }, 0);
  };

  const handleFilter = (filterItems, field) => {
    const updatedFilterMenu = filterMenu?.map((menu) =>
      menu.field === field ? { ...menu, subMenu: filterItems } : menu,
    );
    setFilterMenu(updatedFilterMenu);
    if (field === 'all') {
      setFilteredBaseList(originalRoomTypes);
      setRoomTypes(originalRoomTypes);
      resetFilterDataList();
      isFilterApplied.current = false;
      onsetPage(0);
      return;
    }
    const anyChecked = updatedFilterMenu
      ?.flatMap((m) => m?.subMenu)
      ?.some((item) => item?.selected);
    if (!anyChecked) {
      setFilteredBaseList(originalRoomTypes);
      setRoomTypes(originalRoomTypes);
      resetFilterDataList();
      isFilterApplied.current = false;
      onsetPage(0);
      return;
    }
    isFilterApplied.current = true;
    const filterIdWithFields = updatedFilterMenu
      .filter((m) => m?.subMenu?.length > 0)
      .map((m) => {
        const ids = m?.subMenu?.filter((x) => x?.selected)?.map((x) => x?.id);
        return ids?.length ? { field: m?.field, id: ids } : null;
      })
      .filter((x) => x);

    const filtered = originalRoomTypes?.filter((rt) => {
      return filterIdWithFields?.every((f) => {
        if (f?.field === 'status') {
          return f?.id?.includes(rt?.isActive ? 'active' : 'inactive');
        }
        if (f?.field === 'categoryId') {
          return f?.id?.includes(rt?.categoryId);
        }
        return false;
      });
    });
    setFilteredBaseList(filtered);
    setRoomTypes(filtered);
    onsetPage(0);
  };

  const getRoomNo = (roomType) => {
    return originalRooms.filter((room) => room.roomTypeId === roomType.id).length;
  };

  useOutsideAlerter(wrapperRef, visible, setPopUp);

  const handleSearchInputFocus = (e) => {
    if (selectedInitialRoomTypeLength) {
      searchRef?.current?.blur();
      setShowBulkSearchAlert(true);
    } else {
      setShowBulkSearchAlert(false);
    }
  };

  const dragDisabled =
    searchText?.length > 0 || isFilterApplied?.current || isDragDisabled(roomTypes, searchText);

  const handleActivate = async () => {
    handleClose();
    const selectedLanguage = decryptLocalStorage('lang');
    const language = selectedLanguage !== 'en' ? selectedLanguage : '';
    if (selectedValue.isActive) {
      try {
        await accommodationRoomTypeDeactivate(selectedValue.id, selectedHotel, language);
        dispatch(fetchAllAccommodations(selectedHotel));
        notificationManager('success', 'Room type deactivated successfully');
        setSelectedValue({
          id: '',
          name: '',
          title: '',
          description: '',
          status: false,
          anchorEl: null,
          roomType: null,
        });
      } catch (e) {
        notificationManager(
          'danger',
          e.graphQLErrors ? e.graphQLErrors[0].message : 'Room type deactivated failed',
        );
      }
    } else {
      try {
        await accommodationRoomTypeActivate(selectedValue.id, selectedHotel, language);
        dispatch(fetchAllAccommodations(selectedHotel));
        notificationManager('success', 'Room type activated successfully');
        setSelectedValue({
          id: '',
          name: '',
          title: '',
          description: '',
          status: false,
          anchorEl: null,
          roomType: null,
        });
      } catch (e) {
        notificationManager(
          'danger',
          e.graphQLErrors ? e.graphQLErrors[0].message : 'Room type activated failed',
        );
      }
    }
    setIsAllSelected(false);
    setActionMenuList([]);
  };

  const handleActionMenuOpen = (event) => {
    setActionMenuAnchorEl(event.currentTarget);
  };

  const handleActionMenuClose = () => {
    setActionMenuAnchorEl(null);
  };

  const handleAction = (actionName) => {
    let selectedDiscount = roomTypes?.filter((item) => item?.isChecked);
    switch (actionName) {
      case 'Delete':
        if (selectedDiscount?.length > 0) {
          setShowMultipleDeleteConfirmation(true);
          setActionName('delete');
        }
        break;
      case 'Activate':
        if (selectedDiscount?.length > 0) {
          setShowBulkActiveDeactiveConfirmation(true);
          setActionName('activate');
          setIsActive(true);
        }
        break;
      case 'Deactivate':
        if (selectedDiscount?.length > 0) {
          setShowBulkActiveDeactiveConfirmation(true);
          setActionName('deactivate');
          setIsActive(false);
        }
        break;
      default:
        break;
    }
  };

  const handleCheckboxChange = (id) => {
    let actionListName = [];
    let actionList = [];
    let index = roomTypes?.findIndex((item) => item.id === id);
    if (!roomTypes[index]?.isChecked) {
      roomTypes[index] = {
        ...roomTypes[index],
        isChecked: true,
      };
    } else {
      roomTypes[index].isChecked = !roomTypes[index]?.isChecked;
    }
    setRoomTypes([...roomTypes]);

    actionList = roomTypes?.filter((sInfo) => sInfo?.isChecked).map((status) => status?.isActive);

    const checkedItems = roomTypes?.filter((discount) => discount?.isChecked);

    if (checkedItems.length === 0) {
      setActionMenuList([]);
      setIsAllSelected(false);
      return;
    }

    const isActiveSelected = actionList.includes(true);
    const isInactiveSelected = actionList.includes(false);

    if (isActiveSelected && isInactiveSelected) {
      actionListName.push('Activate', 'Deactivate');
    } else if (isActiveSelected) {
      actionListName.push('Deactivate');
    } else if (isInactiveSelected) {
      actionListName.push('Activate');
    }

    const isAllSelected = roomTypes?.every((item) => item?.isChecked);
    setIsAllSelected(isAllSelected);
    if (!roomTypes[index].isChecked && !actionList?.some((item) => item?.isChecked)) {
      setActionMenuList([]);
    }

    setActionMenuList(actionListName);
  };

  const handleSelectAll = (event) => {
    let selectedMenuList = [];
    let actionListName = [];
    const CheckedValue = event?.target?.checked;
    setIsAllSelected(CheckedValue);
    selectedMenuList = roomTypes?.map((item) => {
      return {
        ...item,
        isChecked: CheckedValue,
      };
    });

    const isActive = selectedMenuList?.some((restaurant) => restaurant?.isActive);
    const isInactive = selectedMenuList?.some((restaurant) => !restaurant.isActive);

    if (isActive && !actionListName?.includes('Deactivate')) {
      actionListName.push('Deactivate');
    }
    if (isInactive && !actionListName?.includes('Activate')) {
      actionListName.push('Activate');
    }
    setRoomTypes([...selectedMenuList]);

    const sortActionMenuList = actionListName.sort((a, b) => {
      const order = { Activate: 1, Deactivate: 2, Delete: 3 };
      return order[a] - order[b];
    });

    setActionMenuList(sortActionMenuList);

    if (!event?.target?.checked && !selectedMenuList?.some((item) => item?.isChecked)) {
      setActionMenuList([]);
    }
  };

  const onApiCallConfirmationNotification = generateConfirmationMessage(
    'Room Type',
    listOfRoomTypeIds?.length,
    isActive,
  );

  const handleMultipleStatusChange = async () => {
    handleClose();
    setActionMenuList([]);
    try {
      dispatch(stepUpLoaderCount());
      setLoading(true);
      const filterApplied = searchText?.length > 0 || isFilterApplied?.current ? true : false;
      const lang = decryptLocalStorage('lang');
      const selectedLang = lang !== 'en' ? lang : '';
      const moduleName = 'ACCOMMODATION_ROOM_TYPE';
      await updateSelectedItemsStatus(
        listOfRoomTypeIds,
        selectedHotel,
        selectedLang,
        moduleName,
        '',
        isActive,
        filterApplied ? false : isAllSelected,
      );
      dispatch(fetchAllAccommodations(selectedHotel));
      notificationManager('success', onApiCallConfirmationNotification);
      setSelectedValue({
        id: '',
        name: '',
        title: '',
        description: '',
        status: false,
        activate: false,
        brand: null,
      });
      setLoading(false);
    } catch (e) {
      notificationManager(
        'danger',
        e.graphQLErrors
          ? e.graphQLErrors[0].message
          : 'The status of the Room Type was not changed',
      );
    } finally {
      dispatch(stepDownLoaderCount());
    }

    setIsAllSelected(false);
    setRoomTypes(ResetFilterList);
  };

  const deleteMultipleSelection = async () => {
    handleClose();
    try {
      setLoading(true);
      const filterApplied = searchText.length > 0 || isFilterApplied?.current ? true : false;
      const lang = decryptLocalStorage('lang');
      const selectedLang = lang !== 'en' ? lang : '';
      const moduleName = 'ACCOMMODATION_ROOM_TYPE';
      await deleteSelectedItems(
        listOfRoomTypeIds,
        selectedHotel,
        selectedLang,
        moduleName,
        '',
        filterApplied ? false : isAllSelected,
      );
      dispatch(fetchAllAccommodations(selectedHotel));
      notificationManager('success', 'Room Type Deleted Successfully');
      setSelectedValue({
        ...selectedValue,
        id: '',
        name: '',
        title: '',
        description: '',
        status: false,
        brand: null,
      });
      setLoading(false);
    } catch (e) {
      notificationManager(
        'danger',
        e.graphQLErrors ? e.graphQLErrors[0].message : 'Room Type Deletion Failed',
      );
    }
    setIsAllSelected(false);
    setRoomTypes(ResetFilterList);
    setActionMenuList([]);
  };

  const roomTypesLabel = selectedInitialRoomTypeLength > 1 ? 'room types' : 'room type';

  return (
    <div className='mt-4 mb-4 room-types group-list-container'>
      {selectedValue.id && selectedValue.status === true && !selectedValue.warn && (
        <DeletePopupModel
          deletePopUp={selectedValue}
          onDelete={deleteRoomType}
          onDeleteCancel={onDeleteCancel}
        />
      )}
      {showMultipleDeleteConfirmation && (
        <MultipleDeleteConfirmationPopup
          title={`Are you sure you want to ${actionName} this selection?`}
          subTitle={`A selection of ${selectedInitialRoomTypeLength} ${roomTypesLabel} will be ${actionName}d. This Action is irreversible.`}
          isOpen={showMultipleDeleteConfirmation}
          onClose={() => setShowMultipleDeleteConfirmation(false)}
          onConfirm={() => {
            deleteMultipleSelection();
          }}
          leftButtonName={'Cancel'}
          rightButtonName={'Delete'}
        />
      )}
      {showBulkActiveDeactiveConfirmation && (
        <MultipleDeleteConfirmationPopup
          title={`Are you sure you want to ${actionName} this selection?`}
          subTitle={`A selection of ${selectedInitialRoomTypeLength} ${roomTypesLabel} will be ${actionName}d.`}
          isOpen={showBulkActiveDeactiveConfirmation}
          onClose={() => setShowBulkActiveDeactiveConfirmation(false)}
          onConfirm={() => {
            handleMultipleStatusChange();
          }}
          leftButtonName={'No'}
          rightButtonName={'Yes'}
        />
      )}
      {selectedValue.id && selectedValue.status === true && selectedValue.warn && (
        <WarningPopup warningPopup={selectedValue} onWarningClose={handleClose} warn={true} />
      )}

      <div className='row mx-2 d-flex'>
        <div
          className='col-12 col-lg-4'
          onClick={() => {
            visible && setPopUp(true);
          }}
        >
          {roomTypes && (
            <TextField
              className='w-100'
              value={searchText}
              inputRef={searchRef}
              focused={false}
              onChange={(e) => {
                handleSearchText(e.target.value);
                setSearchButton(e?.target?.value ? false : true);
              }}
              onFocus={(e) => handleSearchInputFocus(e)}
              label='Search'
              InputProps={
                searchButton && {
                  endAdornment: (
                    <InputAdornment position='end'>
                      <IconButton className='showpopup'>
                        <SearchIcon />
                      </IconButton>
                    </InputAdornment>
                  ),
                }
              }
            />
          )}
        </div>
        <div className='col-12 col-lg-8 pt-3 pt-lg-0 d-flex justify-content-end gap-2'>
          {actionMenuList?.length !== 0 && (
            <div>
              <Button
                onClick={handleActionMenuOpen}
                variant='outlined'
                size='large'
                className='showpopup'
                endIcon={<ArrowDropDownIcon />}
              >
                Actions
              </Button>
              <ActionMenuList
                anchorEl={actionMenuAnchorEl ?? null}
                handleClose={handleActionMenuClose}
                handleAction={handleAction}
                actionMenuItems={actionMenuList}
              />
            </div>
          )}
          <SaveButton
            visible={visible}
            setVisible={setVisible}
            popUp={popUp}
            setPopUp={setPopUp}
            placeHolder={roomTypes}
            setPlaceHolder={setRoomTypes}
            globalPlaceHolder={originalRoomTypes}
            setGlobalPlaceHolder={setAllRoomTypes}
            globalCategoryPlaceHolder={originalCategories}
            globalRoomTypePlaceHolder={originalRoomTypes}
            dispatch={dispatch}
            mappingApi={createDataSortMapping}
            displayText='Accommodations room type'
            module='ACCOMMODATION_ROOM_TYPE'
          />
          {roomTypes && (
            <>
              <Button
                innerRef={filterRef}
                variant='outlined'
                color='secondary'
                size='large'
                endIcon={<ArrowDropDownIcon />}
                onClick={(e) => {
                  handleFilterMenu(e);
                }}
                className={
                  filterMenu?.some((f) => f?.subMenu?.some((s) => s?.selected))
                    ? 'filterButton'
                    : 'showpopup'
                }
              >
                Filter
              </Button>
              <ListFilterMenu
                menu={filterMenu}
                targetEl={filterTargetButton}
                handleFilterClose={() => setFilterTargetButton(null)}
                handleFilter={(items, field) => {
                  handleFilter(items, field);
                }}
              />
            </>
          )}
          {permissions[RBAC_TYPE_HOTEL_ACCOMMODATIONS] === RBAC_PERMISSION_LEVEL_FULL_ACCESS && (
            <Button
              variant='contained'
              color='primary'
              size='large'
              startIcon={<AddCircle />}
              onClick={(e) => {
                onOpenDrawer(e, ROOM_TYPE_CREATE);
              }}
              className='showpopup'
            >
              Add Room Type
            </Button>
          )}
        </div>
      </div>

      <div ref={wrapperRef} className='row mx-2 d-flex mt-4'>
        {loading ? (
          <div className='pt-4 col-md-12'>
            <LinearProgressBar />
          </div>
        ) : (
          roomTypes && (
            <TableContainer>
              <Table className='list-table' aria-label='simple table'>
                <TableHead>
                  <TableRow>
                    <TableCell className={`w-5 ${dragDisabled ? '' : 'ps-5'}`}>
                      <BulkActionCheckBox
                        onChange={handleSelectAll}
                        checked={isAllSelected || false}
                        selectedLength={selectedRoomTypeLength}
                        totalLength={roomTypes?.length}
                        inputProps={{
                          'aria-label': 'select all Room Type',
                        }}
                        className={PARTIAL_CHECKBOX_GREEN}
                      />
                    </TableCell>
                    <TableCell className='w-30'>Room Type Name</TableCell>
                    <TableCell className='w-20'>Category</TableCell>
                    <TableCell className='w-20'>No.of Rooms</TableCell>
                    <TableCell align='center' className='w-20'>
                      Status
                    </TableCell>
                    <TableCell className='w-10' align='right'></TableCell>
                  </TableRow>
                </TableHead>

                <DragDropContext
                  onDragEnd={(event) =>
                    handleOnDragEnd(
                      event,
                      setVisible,
                      roomTypes,
                      setRoomTypes,
                      false,
                      page,
                      rowsPerPage,
                    )
                  }
                  isDropDisabled={dragDisabled}
                >
                  <Droppable droppableId='spas' isDropDisabled={dragDisabled}>
                    {(provided) => (
                      <TableBody {...provided.droppableProps} ref={provided.innerRef}>
                        {(rowsPerPage > 0
                          ? roomTypes.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                          : roomTypes
                        ).map((roomType, i) => (
                          <Draggable
                            key={roomType.id}
                            draggableId={roomType.id}
                            index={i}
                            isDragDisabled={dragDisabled}
                          >
                            {(provided) => (
                              <TableRow
                                key={i}
                                className='border-white pointer'
                                onClick={(e) => {
                                  onViewDetails(roomType, e);
                                }}
                                ref={provided.innerRef}
                                {...provided.draggableProps}
                                {...provided.dragHandleProps}
                              >
                                <TableCell className='w-12'>
                                  {!dragDisabled && (
                                    <span style={{ marginRight: 1.5 }}>
                                      <DragIndicator className='res-menu-accordion-drag' />
                                    </span>
                                  )}
                                  <Checkbox
                                    onChange={(event) => handleCheckboxChange(roomType?.id)}
                                    checked={roomType?.isChecked || false}
                                    inputProps={{
                                      'aria-label': `select Room Type ${roomType?.id}`,
                                    }}
                                  />
                                </TableCell>
                                <TableCell className='w-30'>{roomType?.name}</TableCell>
                                <TableCell className='w-20'>{roomType?.category}</TableCell>
                                <TableCell className='w-20'>{getRoomNo(roomType)}</TableCell>
                                <TableCell className='w-20' align='center'>
                                  <CustomChip
                                    label={roomType.isActive ? 'Active' : 'Inactive'}
                                    color={roomType.isActive ? 'primary' : 'default'}
                                  />
                                </TableCell>
                                <TableCell className='w-10' align='right'>
                                  {permissions[RBAC_TYPE_HOTEL_ACCOMMODATIONS] ===
                                    RBAC_PERMISSION_LEVEL_FULL_ACCESS && (
                                    <Button
                                      aria-controls='simple-menu'
                                      aria-haspopup='true'
                                      onClick={(e) => {
                                        handleCellMenuClick(e, roomType);
                                      }}
                                      className='showpopupInner'
                                    >
                                      <MoreHoriz className='showpopupInner' />
                                    </Button>
                                  )}
                                  <Menu
                                    id={i}
                                    anchorEl={selectedValue?.anchorEl}
                                    disableRestoreFocus
                                    MenuListProps={{ autoFocusItem: false }}
                                    keepMounted
                                    open={
                                      Boolean(selectedValue.anchorEl) &&
                                      selectedValue.id === roomType.id
                                    }
                                    onClose={handleClose}
                                    className='shadow'
                                  >
                                    <MenuItem
                                      className='pe-4'
                                      onClick={(e) => {
                                        handleActivate();
                                      }}
                                    >
                                      {selectedValue?.isActive === true ? (
                                        <>
                                          <RemoveCircle className='me-2 action-menu-icon' />
                                          Deactivate
                                        </>
                                      ) : (
                                        <>
                                          <AddCircle className='me-2 action-menu-icon' />
                                          Activate
                                        </>
                                      )}
                                    </MenuItem>
                                    <MenuItem
                                      className='pe-4'
                                      onClick={(e) => {
                                        onOpenDrawer(e, ROOM_TYPE_EDIT);
                                      }}
                                    >
                                      <CreateIcon className='me-2 action-menu-icon' />
                                      Edit
                                    </MenuItem>
                                    <MenuItem
                                      className='pe-4'
                                      onClick={(e) => {
                                        onClickView(e);
                                      }}
                                    >
                                      <VisibilityIcon className='me-2 action-menu-icon' />
                                      View
                                    </MenuItem>
                                    <MenuItem
                                      className='pe-4'
                                      onClick={(e) => {
                                        deleteAccommodationRoomType(e, roomType.name);
                                      }}
                                    >
                                      <DeleteForeverIcon className='me-2 action-menu-icon' />
                                      Delete
                                    </MenuItem>
                                  </Menu>
                                </TableCell>
                              </TableRow>
                            )}
                          </Draggable>
                        ))}
                        {provided.placeholder}
                      </TableBody>
                    )}
                  </Droppable>
                </DragDropContext>
                <TableFooter>
                  <TableRow className='paginator'>
                    <TablePagination
                      rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
                      count={roomTypes.length}
                      rowsPerPage={rowsPerPage}
                      page={page}
                      SelectProps={{
                        inputProps: { 'aria-label': 'rows per page' },
                        native: true,
                      }}
                      onPageChange={handleChangePage}
                      onRowsPerPageChange={handleChangeRowsPerPage}
                      ActionsComponent={TablePaginationActions}
                    />
                  </TableRow>
                </TableFooter>
              </Table>
            </TableContainer>
          )
        )}
        {showBulkSearchAlert && (
          <MultipleSelectionAlert
            isOpen={showBulkSearchAlert}
            message="If you perform a search after making selections, the items you've selected will be lost."
            leftButtonName='Cancel'
            rightButtonName='Continue'
            onClose={() => setShowBulkSearchAlert(false)}
            onConfirm={handleContinue}
          />
        )}
        {showBulkKebabSelectionAlert && (
          <MultipleSelectionAlert
            isOpen={showBulkKebabSelectionAlert}
            onClose={() => setShowBulkKebabSelectionAlert(false)}
            message='Please select one item from the list that you want to edit.'
            centerButtonName='OK'
          />
        )}
        {showBulkFilterAlert && (
          <MultipleSelectionAlert
            isOpen={showBulkFilterAlert}
            onClose={() => setShowBulkFilterAlert(false)}
            message="If you perform a filter after making selections, the items you've selected will be lost."
            leftButtonName='Cancel'
            rightButtonName='Continue'
            onConfirm={() => {
              handleContinue(true);
            }}
          />
        )}
      </div>
    </div>
  );
};

export default RoomTypeList;
